<div class="dx-cell-link" (click)="onLinkClick()">

  <div class="dx-cell-link__text">
    <a class="dx-cell-link--underline">{{value}}</a>
  </div>

  <ng-container *ngIf="dataTypeOptions && dataTypeOptions.linkIcon">
    <div class="dx-cell-link__icon">
      <img [src]="dataTypeOptions.linkIcon" alt="">
    </div>
  </ng-container>

</div>
